module.exports = __webpack_public_path__ + "static/bg05-0cbc84be3be44923b950e0f2996945c9.jpg";